import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/acondicionador';
import Acondicionador from './AcondicionadorList';


const ms2p = (state) => {
  return {
    ...state.rs_acondicionador,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Acondicionador);
